/**
 * Distintivo visual de cada grupo, derivado de su nombre.
 *
 * No hace falta que nadie suba un logo: cada grupo tiene su inicial y su color
 * desde el primer día, y ninguno se queda con un hueco gris. El color siempre
 * sale igual para el mismo nombre, así que quien trabaja con dos grupos los
 * distingue de un vistazo sin leer.
 */

/** Palabras que no aportan a la inicial: "Iglesia de la Roca" → "IR". */
const VACIAS = ['de', 'del', 'la', 'las', 'el', 'los', 'y', 'e', 'en', 'a'];

/**
 * Una o dos letras. Con dos palabras útiles se toman sus iniciales; con una
 * sola, sus dos primeras letras — "Ensamble" queda "EN" y no una "E" suelta,
 * que se ve pobre en un cuadrado.
 */
export const inicialesDe = (nombre?: string | null): string => {
  const palabras = String(nombre || '')
    .replace(/[—–-]/g, ' ')
    .split(/\s+/)
    .filter(Boolean)
    .filter((p) => !VACIAS.includes(p.toLocaleLowerCase('es')));

  if (!palabras.length) return '··';
  if (palabras.length === 1) return palabras[0].slice(0, 2).toLocaleUpperCase('es');
  return (palabras[0][0] + palabras[1][0]).toLocaleUpperCase('es');
};

/**
 * Colores con contraste suficiente para texto blanco encima (todos por debajo
 * de la luminancia que exige la norma para texto grande). No es una lista al
 * azar: un color claro dejaría las iniciales ilegibles.
 */
const PALETA = [
  '#4338ca', // índigo (la marca)
  '#0f766e', // verde azulado
  '#b91c1c', // rojo
  '#a16207', // ámbar oscuro
  '#7e22ce', // morado
  '#0369a1', // azul
  '#15803d', // verde
  '#be185d', // rosa
  '#c2410c', // naranja
  '#334155'  // pizarra
];

/**
 * Mismo nombre, mismo color, siempre y en todos los dispositivos. Se usa una
 * suma simple de códigos y no algo aleatorio: el color tiene que ser estable o
 * deja de servir para reconocer al grupo.
 */
export const colorDe = (nombre?: string | null): string => {
  const texto = String(nombre || '');
  let suma = 0;
  for (let i = 0; i < texto.length; i++) suma = (suma * 31 + texto.charCodeAt(i)) % 100000;
  return PALETA[suma % PALETA.length];
};
